// import firebasePlugin from '@/plugins/firebase';

// import { UPDATE_TODO_DATE_RANGE } from './actions.type';
import utils from '@/utils';

const initialiDate = utils.date.getToday();

// Iinitialize
const state = {
    categories: ['General'],
    todos: [],
    start: initialiDate.toDate(),
    end: initialiDate.toDate(),
    selectedDate: initialiDate.toDate(),
    selectedCategory: '',
};

const mutations = {
    setDateRange(state, payload) {
        const startDate = new Date(
            payload.startDate.substring(0, 4),
            payload.startDate.substring(5, 7) - 1,
            payload.startDate.substring(8, 10)
        );
        const endDate = new Date(
            payload.endDate.substring(0, 4),
            payload.endDate.substring(5, 7) - 1,
            payload.endDate.substring(8, 10)
        );
        state.start = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        state.end = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    },
    setTodos(state, todos) {
        state.todos = todos;
    },
    setCategories(state, categories) {
        state.categories = categories;
    },
    setSelectedCategory(state, categoryId) {
        state.selectedCategory = categoryId;
    },
};

export default {
    state,
    mutations,
    actions: {},
    modules: {},
};
